// outline blue button

import React from "react";

export default function SolidDisabledBtn({ children, onClick, className }) {
  return (
    <button disabled className={"solid-disabled-btn " + (className ?? "")} onClick={onClick}>
      {children}
    </button>
  );
}
